import { useEffect, useRef } from "react";
import { TextField } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { fetchApi, main_url } from "../../../helper/api";
import { useState } from "react";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import { getBase64, getCookie } from "../../../helper/function";
import { IsAlert } from "../../atoms/IsAlert";
import $ from "jquery";
import "./hover.css";

const InputJembatan = (props) => {
  const [listProv, setListProv] = useState([]);
  const [listKota, setListKota] = useState([]);
  const [listKec, setListKec] = useState([]);
  const [defaultProvinsi, setDefaultProvinsi] = useState(null);
  const [defaultKabkota, setDefaultKabkota] = useState(null);
  const [defaultKecamatan, setDefaultKecamatan] = useState(null);
  const [isDataLocationsFinised, setIsDataLocationsFinised] = useState(false);
  const [image, setImage] = useState();
  const [stateMouse, setStateMouse] = useState(false);
  const [fileUpload, setFileUpload] = useState();
  const [selectedFile, setSelectedFile] = useState();

  const validationSchema = Yup.object().shape({
    // image: Yup.string().required("Gambar tidak boleh kosong"),
    longitude: Yup.string().required("Longitude harus diisi"),
    latitude: Yup.string().required("Latitude harus diisi"),
    // provinsi: Yup.object()
    //   .shape({
    //     label: Yup.string(),
    //     value: Yup.string(),
    //   })
    //   .required("Pilih Provinsi"),
    // kota: Yup.object()
    //   .shape({
    //     label: Yup.string(),
    //     value: Yup.string(),
    //   })
    //   .required("Pilih Kota"),
    // idGeolocations: Yup.object()
    //   .shape({
    //     label: Yup.string().required(),
    //     value: Yup.string().required(),
    //   })
    //   .required("Pilih Kecamatan"),
    alamatLengkap: Yup.string().required("Alamat harus diisi"),
    tahunKonstruksi: Yup.string().required("Tahun harus diisi"),
    panjang: Yup.string().required("Panjang harus diisi"),
    nomorJembatan: Yup.string().required("No. jembatan harus diisi"),
    namaJembatan: Yup.string().required("Nama jembatan harus diisi"),
    konstruksi: Yup.string().required("Konstruksi harus diisi"),
  });

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors, isValid, isError },
  } = useForm(formOptions);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  });

  // console.log("dataIND", props.dataIndividualBridge);

  useEffect(() => {
    getProvinsi();
  }, [props]);

  useEffect(() => {
    if (props.type === "edit" && !isDataLocationsFinised) {
      if (listProv.length !== 0 && !defaultProvinsi) {
        console.log("MASUK LIST PROV");
        listProv?.map((provinsi) => {
          // console.log(provinsi);
          if (
            provinsi.value ===
            props.dataIndividualBridge?.idGeoLocations.substring(0, 2)
          ) {
            setDefaultProvinsi(provinsi);
          }
        });
      } else if (listKota.length <= 0 && defaultProvinsi && !defaultKabkota) {
        console.log("tahap kabkot");
        getKota(defaultProvinsi.value);
      } else if (listKota.length > 0 && defaultProvinsi && !defaultKabkota) {
        listKota.map((kabkota) => {
          if (
            kabkota.value ===
            props.dataIndividualBridge?.idGeoLocations.substring(0, 4)
          ) {
            setDefaultKabkota(kabkota);
          }
        });
      } else if (listKec.length <= 0 && defaultKabkota && !defaultKecamatan) {
        console.log("tahap kec");
        getKecamatan(defaultKabkota.value);
      } else if (listKec.length > 0 && defaultKabkota && !defaultKecamatan) {
        listKec.map((kecamatan) => {
          if (kecamatan.value === props.dataIndividualBridge?.idGeoLocations) {
            setDefaultKecamatan(kecamatan);
            // setValue("idGeolocations", kecamatan.value, {
            //   shouldValidate: true,
            // });
          }
        });
        setIsDataLocationsFinised(true);
      }
    }
  }, [listProv, listKota, listKec, defaultProvinsi, defaultKabkota]);

  const handleUpload = async () => {
    const formdata = new FormData();
    formdata.append("namaLayout", this.state.namaLayoutBaru);
    formdata.append("file", this.state.imagePost, this.state.imagePost.name);

    const tokene = getCookie("token");
    const header = {
      Authorization: `Bearer ` + tokene,
    };
    const requestOptions = {
      method: "POST",
      headers: header,
      body: formdata,
      redirect: "follow",
    };

    const req = await fetch(`${main_url}/api/Bridge`, requestOptions);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          $(".close").click();
        }
      });
    }
  };

  const getProvinsi = async () => {
    setDefaultKecamatan(null);

    const req = await fetchApi("api/GeoLocation/provinsi", "get", true);
    const res = await req.json();
    const newArrayOfObj = res.data.map(
      ({ alt_name: label, id_prov: value, ...rest }) => ({
        label,
        value,
        // ...rest,
      })
    );
    setListProv(newArrayOfObj);
  };

  const getKota = async (id) => {
    // console.log(id);
    setDefaultKabkota(null);
    setDefaultKecamatan(null);

    const req = await fetchApi("api/GeoLocation/provinsi/" + id, "get", true);
    const res = await req.json();
    const newArrayOfObj = res.data.map(
      ({ alt_name: label, id_kabkota: value, ...rest }) => ({
        label,
        value,
        // ...rest,
      })
    );
    setListKota(newArrayOfObj);
  };

  const getKecamatan = async (id) => {
    setDefaultKecamatan(null);
    // console.log(id);
    const req = await fetchApi("api/GeoLocation/kabkota/" + id, "get", true);
    const res = await req.json();
    const newArrayOfObj = res.data.map(
      ({ alt_name: label, id_kecamatan: value, ...rest }) => ({
        label,
        value,
        // ...rest,
      })
    );
    setListKec(newArrayOfObj);
  };

  const fetchUpload = async (data, options) => {
    if (acceptedFiles.length > 0) {
      console.log("ADDD", data);
      const fileUploadImage = await getBase64(acceptedFiles[0])
        .then((result) => {
          acceptedFiles[0]["base64"] = result;
          return acceptedFiles[0];
        })
        .catch((err) => {
          console.log(err);
        });

      const formdata = new FormData();

      formdata.append("image", fileUploadImage, fileUploadImage.name);
      Object.entries(data).map((e) => {
        // console.log("key", e[0]);
        return formdata.append(e[0], e[1]);
      });

      const requestOptionsImg = {
        ...options,
        // headers: { ...options.headers, "Content-Type": "multipart/form-data" },
        body: formdata,
        redirect: "follow",
      };

      const req = await fetch(`${main_url}/api/Bridge`, requestOptionsImg);
      const res = await req.json();
      const status = req.status;
      if (status === 200) {
        IsAlert.fire({
          title: res.status,
          text: res.message,
          icon: "success",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            props.tutupDialog();
            props.updateData();
          }
        });
      } else {
        IsAlert.fire({
          title: res.status,
          text: res.message,
          icon: "error",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            $(".close").click();
          }
        });
      }
    } else {
      alert("Gambar tidak boleh kosong!");
    }
  };

  const fetchUpdate = async (data, options) => {
    let isError = false;
    let messageError = "";
    /// upload information
    const dataForm = {
      ...data,
      id: props.dataIndividualBridge?._id,
      idGeoLocations: defaultKecamatan?.value,
    };
    const requestOptions = {
      ...options,
      headers: { ...options.headers, "Content-Type": "application/json" },
      body: JSON.stringify(dataForm),
    };
    const req = await fetch(`${main_url}/api/Bridge`, requestOptions);
    const res = await req.json();
    const status = req.status;

    if (status !== 200) {
      isError = true;
      messageError = "Update informasi jembatan gagal";
    } else {
      IsAlert.fire({
        title: "Berhasil!",
        // text: `${resImg.message}`,
        text: "Informasi jembatan berhasil diperbaharui",
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          props.tutupDialog();
          props.updateData(props.dataIndividualBridge?._id);
        }
      });
    }

    /// upload image
    if (acceptedFiles.length > 0) {
      // console.log("AF", acceptedFiles);
      const fileUploadImage = await getBase64(acceptedFiles[0])
        .then((result) => {
          acceptedFiles[0]["base64"] = result;
          return acceptedFiles[0];
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log(fileUploadImage);
      let dataImg = new FormData();
      dataImg.set("id", props.dataIndividualBridge?._id);
      dataImg.append("image", fileUploadImage, fileUploadImage.name);

      const requestOptionsImg = {
        ...options,
        // headers: { ...options.headers, "Content-Type": "multipart/form-data" },
        body: dataImg,
        redirect: "follow",
      };
      const reqImg = await fetch(
        `${main_url}/api/Bridge/image`,
        requestOptionsImg
      );
      const resImg = await reqImg.json();
      const statusImg = reqImg.status;

      if (statusImg === 200 && !isError) {
        IsAlert.fire({
          title: resImg.status,
          // text: `${resImg.message}`,
          text: "Informasi jembatan berhasil diperbaharui",
          icon: "success",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            props.tutupDialog();
            props.updateData(props.dataIndividualBridge?._id);
          }
        });
      } else {
        IsAlert.fire({
          title: resImg.status,
          // text: resImg.message,
          text: messageError,
          icon: "error",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            $(".close").click();
          }
        });
      }
    } else {
      if (isError) {
        IsAlert.fire({
          title: res.status,
          // text: `${resImg.message}`,
          text: "Informasi jembatan berhasil diperbaharui",
          icon: "success",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            props.tutupDialog();
            props.updateData(props.dataIndividualBridge?._id);
          }
        });
      }
    }
  };

  const onSubmit = (data) => {
    console.log("ON SUBMIT", data);
    const tokene = getCookie("token");
    const header = {
      Authorization: `Bearer ${tokene}`,
      // "Content-Type": "application/json",
    };
    const options = {
      method: props.type === "edit" ? "PUT" : "POST",
      headers: header,
      // body: formdata,
      // redirect: "follow",
    };

    if (props.type === "edit") {
      fetchUpdate(data, options);
    } else {
      fetchUpload(data, options);
    }
  };

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    // setSelectedFile(e.target.files[0]);
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    setSelectedFile(reader.result);
  };

  useEffect(() => {
    console.log("IDB", props.dataIndividualBridge);
    // console.log("TYPE", props.type);
  }, [props]);

  // console.log("state form", errors, " - ", isValid);
  // console.log("DPROV", defaultProvinsi);
  // console.log("DKABKOT", defaultKabkota);
  // console.log("DKEC", defaultKecamatan);

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      (async () => {
        await getBase64(acceptedFiles[0]).then((result) => {
          acceptedFiles[0]["base64"] = result;
          setImage(result);
        });
      })();
    }
  }, [acceptedFiles]);

  return (
    <form className="m-0 p-4" onSubmit={handleSubmit(onSubmit)}>
      {/* {errors.image && !image ? (
        <span className="text-danger">{errors.image.message}</span>
      ) : (
        ""
      )} */}
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
        className="callbackHover"
      >
        <input {...getInputProps()} />
        {props.type === "add" && !image && (
          <div
            style={{
              border: "3px dashed lightgray",
              width: "100%",
              padding: "1em",
              cursor: "pointer",
            }}
          >
            <div className="d-flex justify-content-center flex-column">
              <i
                className="las la-image text-light"
                style={{
                  fontSize: "5rem",
                  textAlign: "center",
                }}
              ></i>
              <p className="text-center">Drag / Klik untuk memilih gambar</p>
            </div>
          </div>
        )}
        {(props.type === "edit" || image) && (
          <>
            <img
              onMouseOver={() => setStateMouse(true)}
              onMouseOut={() => setStateMouse(false)}
              src={
                image
                  ? image
                  : `${main_url}/api/Bridge/image/${props.dataIndividualBridge?.imgPath}`
              }
              className="w-100 hoverImg"
              alt="bridge"
              // width={100}
              height={500}
              style={{
                backgroundColor: "transparent",
                cursor: "pointer",
                // borderRadius: "10px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                display: !stateMouse ? "none" : "block",
                margin: "0px",
                fontSize: "18px",
                position: "absolute",
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "0.3em",
                opacity: "0.7",
              }}
            >
              Klik untuk mengganti gambar
            </p>
          </>
        )}
      </div>
      <div className="row overflow-auto h-100 mt-4">
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={
              errors.nomorJembatan ? errors.nomorJembatan.message : ""
            }
            {...register("nomorJembatan")}
            type="number"
            className="w-100"
            label="No. Jembatan"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit"
                ? props.dataIndividualBridge?.nomorJembatan
                : null
            }
          // value={props.dataIndividualBridge?.nomorJembatan ?? null}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={errors.namaJembatan ? errors.namaJembatan.message : ""}
            {...register("namaJembatan")}
            className="w-100"
            label="Nama Jembatan"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit"
                ? props.dataIndividualBridge?.namaJembatan
                : null
            }
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={errors.panjang ? errors.panjang.message : ""}
            {...register("panjang")}
            type="number"
            className="w-100"
            label="Panjang"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit" ? props.dataIndividualBridge?.panjang : null
            }
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={
              errors.alamatLengkap ? errors.alamatLengkap.message : ""
            }
            {...register("alamatLengkap")}
            type="text"
            className="w-100"
            label="Alamat"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit"
                ? props.dataIndividualBridge?.alamatLengkap
                : null
            }
          />
        </div>
        <div className="col-lg-4 mb-3">
          <label>Pilih Provinsi</label>
          <Controller
            control={control}
            name="provinsi"
            render={({ field }) => (
              <Select
                className="basic-single"
                classNamePrefix="select"
                // isLoading={listProv.length === 0 ? true : false}
                // isClearable={true}
                isSearchable={true}
                options={listProv}
                onChange={(e) => {
                  field.onChange(e.value);
                  getKota(e.value);
                  setDefaultProvinsi(e);
                }}
                value={defaultProvinsi}
              />
            )}
          />
          {errors.provinsi ? (
            <span className="text-danger">{errors.provinsi.message}</span>
          ) : (
            ""
          )}
        </div>
        <div className="col-lg-4 mb-3">
          <label>Pilih Kota/Kabupaten</label>
          <Controller
            control={control}
            name="kota"
            render={({ field }) => (
              <Select
                className="basic-single"
                classNamePrefix="select"
                isLoading={listProv.length === 0 ? true : false}
                // isClearable={true}
                isSearchable={true}
                options={listKota}
                onChange={(e) => {
                  field.onChange(e.value);
                  getKecamatan(e.value);
                  setDefaultKabkota(e);
                }}
                value={defaultKabkota}
              />
            )}
          />
          {errors.kota ? (
            <span className="text-danger">{errors.kota.message}</span>
          ) : (
            ""
          )}
        </div>
        <div className="col-lg-4 mb-3">
          <label>Pilih Kecamatan</label>
          <Controller
            control={control}
            name="idGeoLocations"
            render={({ field }) => (
              <Select
                className="basic-single"
                classNamePrefix="select"
                isLoading={listProv.length === 0 ? true : false}
                // isClearable={true}
                isSearchable={true}
                options={listKec}
                onChange={(e) => {
                  field.onChange(e.value);
                  setDefaultKecamatan(e);
                }}
                value={defaultKecamatan}
              />
            )}
          />
          {/* <Controller
            as={<Select options={listKec} />}
            control={control}
            rules={{ required: true }}
            onChange={([selected]) => {
              // React Select return object instead of value for selection
              return { value: selected };
            }}
            name="idGeolocations"
          /> */}
          {errors.idGeoLocations ? (
            <span className="text-danger">{errors.idGeoLocations.message}</span>
          ) : (
            ""
          )}
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={
              errors.tahunKonstruksi ? errors.tahunKonstruksi.message : ""
            }
            {...register("tahunKonstruksi")}
            type="number"
            className="w-100"
            label="Tahun Pembangunan"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit"
                ? props.dataIndividualBridge?.tahunKonstruksi
                : null
            }
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={errors.konstruksi ? errors.konstruksi.message : ""}
            {...register("konstruksi")}
            className="w-100"
            label="Tipe Struktur"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.type === "edit"
                ? props.dataIndividualBridge?.konstruksi
                : null
            }
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            helperText={errors.longitude ? errors.longitude.message : ""}
            {...register("longitude")}
            type="number"
            // value={props.data?.lng}
            className="w-100"
            label="Longitude"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.data?.lng
                ? props.data?.lng
                : props.dataIndividualBridge?.longitude
            }
          />
        </div>
        <div className="col-lg-6 mb-3">
          <TextField
            type="number"
            helperText={errors.latitude ? errors.latitude.message : ""}
            {...register("latitude")}
            // value={props.data?.lat}
            className="w-100"
            label="Latitude"
            variant="standard"
            autoComplete="off"
            defaultValue={
              props.data?.lat
                ? props.data?.lat
                : props.dataIndividualBridge?.latitude
            }
          />
        </div>
      </div>
      <div className="row w-100 justify-content-center">
        <div className="col-lg-3 col-6">
          <button
            onClick={props.tutupDialog}
            type="button"
            className="btn btn-light w-100"
          >
            Batal
          </button>
        </div>
        <div className="col-lg-3 col-6">
          <button type="submit" className="btn btn-success w-100">
            Simpan
          </button>
        </div>
      </div>
    </form>
  );
};
export default InputJembatan;
